import { render, staticRenderFns } from "./wxgame-playable-selector.vue?vue&type=template&id=f9fb80d8&scoped=true"
import script from "./wxgame-playable-selector.vue?vue&type=script&setup=true&lang=js"
export * from "./wxgame-playable-selector.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fb80d8",
  null
  
)

export default component.exports